<script lang="ts">
    import TestimonialSlider from '$lib/components/_DisplayComponents/TestimonialSlider.svelte';

    // Types
    import type { TransitionEffect } from '$lib/types/Theme';
    import type { TestimonialSliderContent } from '$lib/types/Components/TestimonialSlider/TestimonialSliderContent';
    import type { Layout } from '$lib/types/Components/SharedTypes';

    export let content: TestimonialSliderContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout: Layout;
</script>

<svelte:component
    this={TestimonialSlider}
    testimonials={content.testimonials}
    framed={content.framed}
    bgColor={content.box.backgroundColor}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
